import React from 'react'
import Address from '../shared/address'
import {fetchSchedule, fetchTaskPrices} from '../api'
import moment from 'moment'
import CalendarIcon from '../schedule/calendar-icon/calendar-icon.jsx'
import CalendarTasksDisplay from '../schedule/calendar-tasks-display.jsx'
import DayPicker from 'react-day-picker';
import './calendar.css'
import JobDetailsModal from '../modals/task-details-modal'
import UpdateInstructionsModal from '../modals/update-instructions-modal'
import TaskOptionsModal from '../modals/task-options-modal'
import TaskEditModal from '../modals/task-edit-modal'
import UpgradeFrequencyModal from '../modals/upgrade-frequency-modal'
import UpgradeServiceModal from '../modals/upgrade-service-modal'
import SkipJobModal from '../modals/skip-job-modal'
import NotificationModal from '../modals/notification-modal'
import ReactGA from 'react-ga'

var days = [];
export default React.createClass({
  getInitialState: function () {

    return {
      daySchedule: undefined,
      date: moment(),
      focused: null,
      monthSchedule: [],
      address: null,
      currentMonth: moment().month() + 1,
      currentYear: moment().year(),
      skipJobModal: false,
      showEditTaskModal: false,
      showUpdateInstructionsModal: false,
      showUpgradeScheduleModal: false,
      showUpgradeServiceModal: false,
      showUpgradeFrequencyModal: false,
      showSkipJobModal: false,
      showNotificationModal: false,
      notificationTitle: '',
      notificationContent: '',
      currentlySelectedAddressId: '',
      loading: true,
      tasksForDay: '',
      pricingArray: [],
      showJobDetailsModal: false,
      modalCard: '',
      month: '',
      days: ''
    }
  },
  componentDidMount: function () {
    this.refreshPage(this.props)
  },
  componentWillReceiveProps: function (nextProps) {

    this.refreshPage(nextProps)
  },

  populateCalendar: function (data) {
    if (data.length !== 0) {
      let name;
      let dayss = [];
      for (let i = 0; i < data.length; i++) {
        name = moment(data[i].scheduledDay * 24 * 60 * 60 * 1000).date() + 1
        dayss.push({
          [name]: {
            day: moment(data[i].scheduledDay * 24 * 60 * 60 * 1000).date() + 1,
            month: moment(data[i].scheduledDay * 24 * 60 * 60 * 1000).month(),
            year: moment(data[i].scheduledDay * 24 * 60 * 60 * 1000).year(),
            data: data[i]
          }
        })

        days = dayss;
      }
      this.setState({days: days});
    } else {
      this.setState({days: []})
    }
  },
  renderDay: function (day) {
    const date = day.getDate();
    let show = [];
    let smallShow = [];
    let newDate = [];
    let classColor;
    let tri = [];
    for (let i = 0; i < this.state.days.length; i++) {
      if (this.state.days[i][date]) {
        if (this.state.days[i][date].month === day.getMonth() && this.state.days[i][date].day === day.getDate()) {
           if(this.state.days[i][date].data.workFlowStep !== 'JOB_SKIPPED'){
              tri.push(this.state.days[i][date])
              classColor = 'grey-box'
           }     
        }
      }
    }

   
    if(tri.length !== 0){
      show.push(
        <div key={tri.length} className='hidden-xs' >
          <CalendarIcon key={'b'} data={tri} show={this.openJobDetailsModal} icon={true}/>
        </div>
      )
      smallShow.push(
         <div key={tri.length + 1} className='visible-xs' style={{position: 'relative', top: -25}} >
          <CalendarIcon key={'b'} data={tri}/>
        </div>
      )
      newDate.push(
        <div key={tri.length + 2} className='calendar-date calendar-day' style={{zIndex: 12}} onClick={() => this.calendarDisplayShow(tri)}>
            {date}
        </div>
      )
    }else{
       newDate.push(<div key='x' className='calendar-day' onClick={() => this.calendarDisplayShow(tri)}>
            {date}
        </div>)                                                                                                                                                                                           
    }


    
    return (
      <div className={'calendar-box ' + classColor}>
        {newDate}
        {show}
        <div style={{position: 'relative', zIndex: 1, top: 12}}>
        {smallShow}
        </div>
      </div>

    );
  },
  refreshPage: function (props) {
     let address = this.props.currentAddress;
    if(props){
      address = props.currentAddress;
    }
     fetchSchedule(address.addressId, this.state.currentMonth, this.state.currentYear).then((data) => {
      this.populateCalendar(data);
    })
    if (address !== null) {
      let {addressId} = address
      if (addressId) 
        this.setState({currentlySelectedAddressId: addressId})
    }
    days = [];

    if(this.state.pricingArray.length === 0) {
      let tempArray = []
      fetchTaskPrices('MOWLAWN', this.props.currentAddress.addressId).then((data) => {
        for(let i = 0; i < data.data.length; i++) {
          tempArray.push(data.data[i])
        }
        this.setState({pricingArray: tempArray})
      })
    }
  },
  called: function(day) {
    fetchSchedule(this.state.currentlySelectedAddressId, day.getMonth() + 1, day.getYear() + 1900).then((data) => {
      this.setState({currentMonth: day.getMonth() + 1})
      this.populateCalendar(data);
    })
  },
  calendarDisplayShow: function (tri) {
    this.setState({tasksForDay: tri})
    ReactGA.event({
      category: tri ? 'Calendar Icon Click - Mobile' : 'Calendar Icon Miss - Mobile',
      action: 'click',
      label: 'Calendar Icon'
    })
  },

  //Start of opening modals
  openJobDetailsModal: function (modalCard) {
    ReactGA.event({
      category: 'Calendar Icon Click - Desktop',
      action: 'click',
      label: 'Calendar Icon'
    })
    ReactGA.pageview('JobDetailsModal');
    this.setState({showJobDetailsModal: true, modalCard: modalCard, showTaskOptionsModal: false})
  },
  closeJobDetailsModal: function () {
    this.setState({showJobDetailsModal: false})
  },
  openEditTaskModal: function (cardInfo) {
    ReactGA.pageview('EditTaskModal');
    this.setState({showEditTaskModal: true, showJobDetailsModal: false, modalTasks: cardInfo.modalCard})
  },
  closeEditTaskModal: function () {
    this.setState({showEditTaskModal: false})
  },
  openUpgradeScheduleModal: function () {
    ReactGA.pageview('UpgradeScheduleModal');
    this.setState({showUpgradeScheduleModal: true, showEditTaskModal: false})
  },
  closeUpgradeScheduleModal: function () {
    this.setState({showUpgradeScheduleModal: false})
  },
  openUpdateInstructionsModal: function() {
    ReactGA.pageview('UpdateInstructionsModal');
    this.setState({showUpdateInstructionsModal: true, showEditTaskModal: false})
  },
  closeUpdateInstructionsModal: function() {
    this.setState({showUpdateInstructionsModal: false})
    this.refreshPage();
  },
  openUpgradeServiceModal: function (task) {
    ReactGA.pageview('UpgradeServiceModal');
    if(task !== '') {
      this.setState({showUpgradeServiceModal: true, showEditTaskModal: false, modalTasks: task})
    }
    else {
     this.setState({showUpgradeServiceModal: true, showEditTaskModal: false})
    }
  },
  closeUpgradeServiceModal: function () {
    this.setState({showUpgradeServiceModal: false})
    this.refreshPage();
  },
  openUpgradeFrequencyModal: function (task) {
    ReactGA.pageview('UpgradeFrequencyModal');
    if(task !== '') {
     this.setState({showUpgradeFrequencyModal: true, showEditTaskModal: false, modalTasks: task})
    }
    else {
     this.setState({showUpgradeFrequencyModal: true, showEditTaskModal: false})
    }
  },
  closeUpgradeFrequencyModal: function () {
    this.setState({showUpgradeFrequencyModal: false})
    this.refreshPage();
  },
  openSkipJobModal: function () {
    ReactGA.pageview('SkipJobModal');
    this.setState({showSkipJobModal: true, showJobDetailsModal: false})
  },
  closeSkipJobModal: function () {
    this.setState({showSkipJobModal: false})
    this.refreshPage();
  },
  openNotificationModal: function(closingModal, notificationTitle, notificationContent) {
    ReactGA.pageview('NotificationModal');
    this.setState({showNotificationModal: true, [closingModal]: false, notificationTitle: notificationTitle, notificationContent: notificationContent})
  },
  closeNotificationModal: function() {
    this.setState({showNotificationModal: false})
  },
  //End of opening modals
  
  render: function () {
    if (!this.props.loginData) {
      return (
        <div></div>
      )
    }
    let loginData = this.props.loginData
    let customerAddresses = []
    for (let i = 0; i < loginData.customer.addresses.length; i++) {
      let addressData = loginData.customer.addresses[i]
      let customerAddress = addressData.streetAddress + ', ' + addressData.city
      customerAddresses.push(customerAddress)
    }

    return (
      <div className='concrete-gray-background schedule-wrap'>
        <JobDetailsModal show={this.state.showJobDetailsModal} hide={this.closeJobDetailsModal} description={this.state.modalCard.content} modalCard={this.state.modalCard} showSkipJob={this.openSkipJobModal} showEditTask={this.openEditTaskModal}/>
        <SkipJobModal show={this.state.showSkipJobModal} hide={this.closeSkipJobModal} modalCard={this.state.modalCard} openNotificationModal={this.openNotificationModal}/>
        <TaskEditModal task={this.state.modalTasks} show={this.state.showEditTaskModal} hide={this.closeEditTaskModal} openUpgradeServiceModal={this.openUpgradeServiceModal} openUpgradeFrequencyModal={this.openUpgradeFrequencyModal} openUpgradeScheduleModal={this.openUpgradeScheduleModal} openUpdateInstructionsModal={this.openUpdateInstructionsModal} fullComponent={true}/>
        <UpdateInstructionsModal show={this.state.showUpdateInstructionsModal} hide={this.closeUpdateInstructionsModal} modalCard={this.state.modalCard} openNotificationModal={this.openNotificationModal}/>
        <UpgradeServiceModal show={this.state.showUpgradeServiceModal} hide={this.closeUpgradeServiceModal} task={this.state.modalTasks} addressId={this.state.currentlySelectedAddressId} openNotificationModal={this.openNotificationModal} pricingArray={this.state.pricingArray}/>
        <UpgradeFrequencyModal show={this.state.showUpgradeFrequencyModal} hide={this.closeUpgradeFrequencyModal} task={this.state.modalTasks} openNotificationModal={this.openNotificationModal} pricingArray={this.state.pricingArray}/>
        <TaskOptionsModal show={this.state.showTaskOptionsModal} hide={this.closeTaskOptionsModal} open={this.openJobDetailsModal} data={this.state.tasksForDay}/>
        <NotificationModal hide={this.closeNotificationModal} show={this.state.showNotificationModal} title={this.state.notificationTitle} content={this.state.notificationContent}/>

        <div className='container-cards'>
          <div className='row'>
            <div className='col-xs-12 history-wrap'>
              <div className='row pull-down-sm-1'>
                <div className='col-sm-5 col-xs-12'>
                  <h3 className='hidden-xs' style={{ textAlign: 'left'}}>My Task Schedule</h3>
                  <h3 className='visible-xs'>My Task Schedule</h3>
                </div>
                <div className='col-sm-7 col-xs-12 text-right address'>
                  <Address addresses={customerAddresses} curIndex={this.props.curAddressIndex} onChange={this.props.reportAddressChange}/>
                </div>
              </div>
              <div>
              <DayPicker enableOutsideDays onMonthChange={day => this.called(day)} renderDay={day => this.renderDay(day)}/>
              <div className='visible-xs'>
                <CalendarTasksDisplay data={this.state.tasksForDay} open={this.openJobDetailsModal}/>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
})


// WEBPACK FOOTER //
// ./src/components/schedule/schedule.jsx